/**
 * Extended line tool
 * @constructor
 * @class ExtendedLineTool
 * @extends LineTool
 */
import LineTool from './LineTool';

class ExtendedLineTool extends LineTool {
	_getDefaultParams() {
		return {
			id: 'extendedLine',
			name: 'Extended Line',
			extendLeft: true,
			extendRight: true,
			style: this.core.getStyle('tool.extendedLine')
		};
	}
}

export default ExtendedLineTool;
